<script>
import Drawer from "@/components/drawer";

// Custom components
import PageHeader from "@/components/page-header";
import slotAddEditDrawer from "@/components/superAdmin/videoBot/slot/slotAddEditDrawer.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Master Slot List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Master Slot List",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Master Slot List",
          active: true,
        },
      ],
      addEditSlot: false,
      openNewRequestForm: false,
      isEdit: false,
      tableData: [],
      updateValue: "",
      isDataLoading: false,
      is_btn_loading: false,
      selected: "all",
      isBtnLoading: false,
      sortedbyASC: true,
    };
  },
  components: {
    PageHeader,
    Drawer,
    slotAddEditDrawer,
  },
  computed: {
    ...authComputed,
    intentProps() {
      return {
        isEdit: this.isEdit,
        updateValue: this.updateValue,
      };
    },
  },
  mounted() {
    this.getListOfSlots();
  },

  methods: {
    // Get list of all intents
    async getListOfSlots() {
      this.isDataLoading = true;
      await UserService.getSlotList().then((response) => {
        this.tableData = response.slotList;
        this.isDataLoading = false;
      });
    },

    addEditSlotDrawer() {
      if (this.addEditSlot === true) {
        this.isEdit = false;
        this.updateValue = "";
      }
      this.addEditSlot = !this.addEditSlot;
    },

    slotAddedUpdated(data, isEdit) {
      if (isEdit) {
        this.tableData = this.tableData.map((item) => {
          if (item.slot_name === data.slot_name) {
            item = data;
          }
          return item;
        });
        this.addUpdateAvatarSlot(data, "edit");
      } else {
        this.addUpdateAvatarSlot(data, "add");
        this.tableData.push(data);
      }
      this.addEditSlotDrawer();
    },

    saveAndAddNewSlot(data) {
      this.tableData.push(data);
      this.addEditSlotDrawer();
    },

    editSlot(data, index) {
      this.isEdit = true;
      this.updateValue = data;
      this.addEditSlotDrawer();
    },

    async deployBot() {
      this.isBtnLoading = true;
      await UserService.deployBot()
        .then(() => {
          this.isBtnLoading = false;
          this.createError = true;
        })
        .catch((error) => {
          this.isBtnLoading = false;
          this.createError = true;
          errorHandler(error);

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    async addUpdateAvatarSlot(data, type) {
      await UserService.getBotAvatarList().then((avatar) => {
        avatar.avatarList.map(async (item) => {
          let tempObj = {};
          tempObj[data.slot_name] = {
            name: data.slot_name,
            id: data.slot_name,
            video_file: data.video_file,
            text_reply: data.text_reply,
            is_common: true,
          };

          tempObj = {
            ...tempObj,
            id: item.id,
          };
          await UserService.addUpdateBotAvatarIntent(tempObj).then(
            (response) => {
              console.log(response, "response");
            }
          );
        });
      });
    },

    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.tableData.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
      } else {
        this.tableData.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :items="items"
      :action="addEditSlotDrawer"
      text="Add New"
      :isButton="true"
    />

    <div class="card">
      <div class="card-body">
        <div class="row mt-1 mb-3">
          <div class="col-md-3 d-flex align-items-start">
            <b-button
              class="float-end w-50"
              variant="outline-primary"
              type="button"
              :class="{ disabled: isBtnLoading }"
              @click="deployBot"
            >
              <i
                v-if="isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              Deploy</b-button
            >
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th class="w-300" @click="sortList('intent_name')">
                  Slot &#8597;
                </th>
                <th class="w-500">Reply</th>
                <th class="w-25">Action</th>
              </tr>
            </thead>
            <tbody v-if="isDataLoading">
              <tr v-for="(item, index) in 10" :key="index">
                <td class="placeholder-glow" v-for="no in 3" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(data, index) in tableData" :key="data.id">
                <td @click="openBotDrawer(data.id, index)">
                  {{ data.slot_name }}
                </td>
                <td class="text-wrap">
                  <p class="mb-0">
                    {{ data.text_reply }}
                  </p>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      class="fas fa-video fs-5 mx-4 fs-4"
                      :class="[
                        data.video_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                    <i
                      class="fas fa-pencil-alt text-success fs-5"
                      @click="editSlot(data)"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="addEditSlotDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="addEditSlot">
        <slotAddEditDrawer
          :currentProps="intentProps"
          @submitted="slotAddedUpdated"
          @cancelSubmit="addEditSlotDrawer"
          @saveAndAddNew="saveAndAddNewSlot"
        ></slotAddEditDrawer>
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-500 {
  width: 500px;
}
.w-300 {
  width: 300px;
}
</style>
